import React, { Fragment } from "react";

import CompanyCardItem from "./CompanyCardItem";

const CompanyPositionItem = ({ episode: { currentepisode } }) => {
  return (
    <Fragment>
      {currentepisode && currentepisode.jobpositions
        ? currentepisode.jobpositions.map((jobposition) => (
            <CompanyCardItem key={jobposition._id} jobposition={jobposition} />
          ))
        : null}
    </Fragment>
  );
};

export default CompanyPositionItem;
